import { apiFetch, apiFetchJson } from '@/lib/api-fetch'

export interface AppFreeVhfProgressRow {
  scenario_id: string
  completed_at: string | null
}

export async function fetchAppFreeVhfProgress(): Promise<AppFreeVhfProgressRow[]> {
  return apiFetchJson<AppFreeVhfProgressRow[]>('/api/app/v1/free-vhf-progress')
}

export async function recordAppFreeVhfProgress(scenarioId: string): Promise<boolean> {
  const res = await apiFetch('/api/app/v1/free-vhf-progress', {
    method: 'POST',
    json: { scenario_id: scenarioId },
  })
  return res.ok
}
